import type { TFunction } from "i18next";
import { runDeleteAccount, type AccountActionOutcome } from "@heraion/ui";
import { apiFetch } from "../api";
import { confirmViaWindow } from "../confirm";

/** The web's injection of the shared delete-account flow: Settings → Account
 *  and the age gate (#383) both call this one. */
export const deleteAccount = ({
  t,
  signOut,
  onBusy,
}: {
  t: TFunction;
  signOut: () => void | Promise<void>;
  onBusy: (busy: boolean) => void;
}): Promise<AccountActionOutcome> =>
  runDeleteAccount({ confirm: confirmViaWindow, apiFetch, signOut, t, onBusy });
